import react,{useState} from "react";

import FilterView from "../../Fragments/Filter/FilterView";

// Page Components:
import ReactSelect from "../UI Components/Inputs/ReactSelect";

// MUI Components
import Box from '@mui/material/Box';
import DrawerAppBar from "../UI Components/Navbar/DrawerAppBar";

// context
import { useAppData } from "../../Context/AppDataContext";

// router
import { useLocation } from "react-router";

// Utils
import { handleCompDisplay } from "../../utility/utils";


function PageSidebar() {

    const appData  = useAppData();
    const location = useLocation();
    // const [currLoc,setCurrLoc] = useState("/");

    console.log(location,"from sidebar");

    const onFilterClose = () => {}

    // sx={{ display: () => handleCompDisplay('sideBar',"/")}}
    return(
        <Box>
            <FilterView onFilterClose={onFilterClose} ></FilterView>
        </Box>
    );
}

export default PageSidebar;